import React from 'react';
import { useRouter } from 'next/router';
import { MemberSignInContainer } from 'Components/widgets/member-nav/member-sign-in/MemberSignIn.container';
import { LoggedNav } from './logged-nav/LoggedNav';
import { QuickLoggedNavContainer } from './quicklogged-nav/QuickLoggedNav.container';
type Props = {
  closeMemberPanel?: () => void;
  userInfo: UserInfoSummary;
};
export const MemberNav = ({ closeMemberPanel, userInfo }: Props) => {
  const {
    query: { cxo_neolid: cxoNeolid },
  } = useRouter();

  if (userInfo.isQuickLoggedIn) {
    return <QuickLoggedNavContainer closeMemberPanel={closeMemberPanel} />;
  }

  if (userInfo.isLoggedIn || cxoNeolid) {
    return <LoggedNav closeMemberPanel={closeMemberPanel} userInfo={userInfo} />;
  }

  return <MemberSignInContainer />;
};
